module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1024-9490fc6e4b560aa5c9bdb4b714262f7d.png";